import React from "react";

export default function Section2() {
  return (
    <div className="w-full Section2">
      {/* Logos row stays same */}
      <div className="w-[90%] flex justify-center items-center section2-container mx-auto pt-5">
        <div className="mx-5">
          <img
            className="w-[120px]"
            alt="Awards Logos"
            src="/assets/go-awards-logo.png"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[97px]"
            alt="Awards Logos"
            src="../../../../assets/award2.png"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[119px]"
            alt="Awards Logos"
            src="../../../assets/secp-logo.jpg"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[116px]"
            alt="Awards Logos"
            src="/assets/pasha-logo.jpg"
          />
        </div>
      </div>
    </div>
  );
}
